"use client"

import { useState, useEffect } from "react"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import DataTable from "examples/Tables/DataTable"
import Button from "@mui/material/Button"
import Paper from "@mui/material/Paper"
import InputBase from "@mui/material/InputBase"
import CircularProgress from "@mui/material/CircularProgress"
import { ToastContainer, toast } from "react-toastify"
import MDBadge from "components/MDBadge"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Checkbox from "@mui/material/Checkbox"
import FormControlLabel from "@mui/material/FormControlLabel"
import ListItemText from "@mui/material/ListItemText"
import OutlinedInput from "@mui/material/OutlinedInput"
import FilterListIcon from "@mui/icons-material/FilterList"
import SearchIcon from "@mui/icons-material/Search"
import DownloadIcon from "@mui/icons-material/Download"
import VisibilityIcon from "@mui/icons-material/Visibility"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"
import GetAppIcon from "@mui/icons-material/GetApp"
import Alert from "@mui/material/Alert"
import AlertTitle from "@mui/material/AlertTitle"
import Box from "@mui/material/Box"
import "react-toastify/dist/ReactToastify.css"

const BASE_URL = process.env.REACT_APP_BASE_URL
const token = sessionStorage.getItem("token")

const BANKS = ["HBL", "UBL", "NBP", "BAL"]
const VOUCHER_TYPES = ["Common Room", "Room Allocation", "Room Rent"]
const VOUCHER_STATUS = ["paid", "un-paid"]
const FILTER_VOUCHER_TYPES = ["Common Room", "Room Allocation", "Both"]
const STUDENT_TYPES = ["Old Students", "New Students", "Both"]
import { hasAdmissionPermission } from "hooks/permissions";
function HostelVouchers() {
  const [voucherNumber, setVoucherNumber] = useState("")
  const [loading, setLoading] = useState(false)
  const [vouchers, setVouchers] = useState([])
  const [selectedVoucher, setSelectedVoucher] = useState(null)

  // Pay voucher modal states
  const [payModalOpen, setPayModalOpen] = useState(false)
  const [selectedBank, setSelectedBank] = useState("")
  const [transactionId, setTransactionId] = useState("")
  const [paymentDateTime, setPaymentDateTime] = useState("")
  const [payingVoucherCode, setPayingVoucherCode] = useState("")

  // Bulk pay modal states
  const [bulkPayModalOpen, setBulkPayModalOpen] = useState(false)
  const [csvFile, setCsvFile] = useState(null)
  const [csvData, setCsvData] = useState([])
  const [csvErrors, setCsvErrors] = useState([])
  const [bulkPayLoading, setBulkPayLoading] = useState(false)
  const [successVouchers, setSuccessVouchers] = useState([])
  const [errorVouchers, setErrorVouchers] = useState([])

  // Filter modal states
  const [filterModalOpen, setFilterModalOpen] = useState(false)
  const [filterVoucherTypes, setFilterVoucherTypes] = useState("")
  const [filterStatus, setFilterStatus] = useState("")
  const [filterStudentType, setFilterStudentType] = useState("")
  const [filterStartDate, setFilterStartDate] = useState("")
  const [filterEndDate, setFilterEndDate] = useState("")
  const [filterBank, setFilterBank] = useState("")
  const [filterBuildingIds, setFilterBuildingIds] = useState([])

  // Filter not pushed to SAP modal states
  const [filterNotPushedModalOpen, setFilterNotPushedModalOpen] = useState(false)
  const [notPushedVoucherTypes, setNotPushedVoucherTypes] = useState("")
  const [notPushedStudentType, setNotPushedStudentType] = useState("")
  const [notPushedStartDate, setNotPushedStartDate] = useState("")
  const [notPushedEndDate, setNotPushedEndDate] = useState("")
  const [notPushedBank, setNotPushedBank] = useState("")
  const [notPushedBuildingIds, setNotPushedBuildingIds] = useState([])
  const [notPushedExcludeZeroFee, setNotPushedExcludeZeroFee] = useState(false)
  const [bulkSearchModalOpen, setBulkSearchModalOpen] = useState(false)
  const [bulkSearchInput, setBulkSearchInput] = useState("")
  const [bulkSearchLoading, setBulkSearchLoading] = useState(false)
  
  // Buildings list
  const [buildings, setBuildings] = useState([])

  // View Log modal states
  const [logModalOpen, setLogModalOpen] = useState(false)
  const [logVoucher, setLogVoucher] = useState(null)
  const [actionLogs, setActionLogs] = useState([])
  const [actionLogsLoading, setActionLogsLoading] = useState(false)

  // Fetch buildings on component mount
  const fetchBuildings = async () => {
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/get_buildings`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      const data = await response.json()
      if (response.ok && data.buildings) {
        setBuildings(data.buildings)
      }
    } catch (error) {
      console.error("Error fetching buildings:", error)
    }
  }

  // Fetch buildings when component mounts
  useEffect(() => {
    fetchBuildings()
  }, [])

  // Export vouchers function
  const exportVouchers = () => {
    if (!vouchers || vouchers.length === 0) {
      toast.error("No vouchers to export")
      return
    }
    try {
      const headers = [
        "Voucher Code",
        "Voucher Type",
        "Status",
        "Amount",
        "Due Date",
        "Transaction ID",
        "Payment Date",
        "Student Name",
        "Student Phone",
        "Student CNIC",
        "Bank",
        "Created Date",
      ]

      const csvData = vouchers.map((voucher) => [
        voucher.voucher_code || "",
        voucher.voucher_type || "",
        voucher.voucher_status === "paid" ? "Paid" : "Not Paid",
        voucher.amount || "",
        voucher.due_date
          ? new Date(voucher.due_date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "long",
              year: "numeric",
              timeZone: "Asia/Karachi",
            })
          : "",
        voucher.transaction_id || "",
        voucher.payment_date || "",
        voucher.student_name || "",
        voucher.student_phone || "",
        voucher.student_cnic || "",
        voucher.bank || "",
        voucher.created_at ? new Date(voucher.created_at).toLocaleDateString("en-GB") : "",
      ])

      const csvContent = [headers, ...csvData].map((row) => row.map((field) => `"${field}"`).join(",")).join("\n")

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
      const link = document.createElement("a")
      const url = URL.createObjectURL(blob)
      link.setAttribute("href", url)
      link.setAttribute("download", `hostel_vouchers_${new Date().toISOString().split("T")[0]}.csv`)
      link.style.visibility = "hidden"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      toast.success(`Successfully exported ${vouchers.length} vouchers`)
    } catch (error) {
      console.error("Export error:", error)
      toast.error("Error exporting vouchers")
    }
  }

  // Fetch voucher by code
  const parseVoucherCodes = (rawText) => {
    if (!rawText) return []
    const tokens = rawText
      .split(/[\s,\t;\r\n]+/)
      .map((t) => t.trim().replace(/^"|"$/g, ""))
      .filter(Boolean)
      .filter((t) => !["voucher_code", "voucher", "code"].includes(t.toLowerCase()))
    return [...new Set(tokens)]
  }

  const handleBulkVoucherSearch = async () => {
    const voucherCodes = parseVoucherCodes(bulkSearchInput)
    if (voucherCodes.length === 0) {
      toast.error("Please paste voucher codes")
      return
    }

    setBulkSearchLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/get_hostel_vouchers_by_codes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          voucher_codes: voucherCodes,
        }),
      })

      const data = await response.json()
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers)
        if (Array.isArray(data.not_found_codes) && data.not_found_codes.length > 0) {
          toast.warning(`Found ${data.vouchers.length} vouchers. Not found: ${data.not_found_codes.length}`)
        } else {
          toast.success(`Found ${data.vouchers.length} vouchers`)
        }
        setBulkSearchModalOpen(false)
      } else {
        setVouchers([])
        toast.error(data.error || "No vouchers found")
      }
    } catch (error) {
      console.error("Error fetching vouchers:", error)
      toast.error("Error fetching vouchers")
      setVouchers([])
    } finally {
      setBulkSearchLoading(false)
    }
  }

  const fetchVoucherByCode = async () => {
    if (!voucherNumber.trim()) {
      toast.error("Please enter a voucher code")
      return
    }

    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/get_hostel_voucher_by_code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          voucher_code: voucherNumber.trim(),
        }),
      })

      const data = await response.json()

      if (response.ok && data.vouchers) {
        setVouchers(Array.isArray(data.vouchers) ? data.vouchers : [data.vouchers])
        toast.success("Voucher fetched successfully")
      } else {
        setVouchers([])
        toast.error(data.error || "Voucher not found")
      }
    } catch (error) {
      console.error("Error fetching voucher:", error)
      toast.error("Error fetching voucher")
      setVouchers([])
    } finally {
      setLoading(false)
    }
  }

  // Filter vouchers
  const filterVouchers = async () => {
    if (!filterVoucherTypes || !filterStatus || !filterStudentType || !filterStartDate || !filterEndDate) {
      toast.error("Please select voucher type, status, student type, and date range")
      return
    }

    setLoading(true)
    try {
      const voucherTypeString = `'${filterVoucherTypes}'`

      const response = await fetch(`${BASE_URL}/fee_voucher/filter_hostel_vouchers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          voucher_type: voucherTypeString,
          status: filterStatus,
          student_type: filterStudentType,
          start_date: filterStartDate,
          end_date: filterEndDate,
          bank: filterBank || "All",
          building_ids: filterBuildingIds,
        }),
      })

      const data = await response.json()

      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers)
        toast.success(`Found ${data.vouchers.length} filtered vouchers`)
        setFilterModalOpen(false)
        // resetFilterModal()
      } else {
        setVouchers([])
        toast.error(data.error || "No vouchers found for the selected criteria")
      }
    } catch (error) {
      console.error("Error filtering vouchers:", error)
      toast.error("Error filtering vouchers")
      setVouchers([])
    } finally {
      setLoading(false)
    }
  }

  // Fetch manual paid vouchers
  const getManualPaidVouchers = async () => {
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/get_hostel_manual_paid_vouchers`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = await response.json()

      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers)
        toast.success(`Found ${data.vouchers.length} manual paid vouchers`)
      } else {
        setVouchers([])
        toast.error(data.error || "No manual paid vouchers found")
      }
    } catch (error) {
      console.error("Error fetching manual paid vouchers:", error)
      toast.error("Error fetching manual paid vouchers")
      setVouchers([])
    } finally {
      setLoading(false)
    }
  }

  // Filter not pushed to SAP vouchers
  const filterNotPushedToSAP = async () => {
    if (!notPushedVoucherTypes || !notPushedStartDate || !notPushedEndDate || !notPushedStudentType) {
      toast.error("Please select voucher type, student type, and date range")
      return
    }

    setLoading(true)
    try {
      const voucherTypeString = `'${notPushedVoucherTypes}'`

      const response = await fetch(`${BASE_URL}/fee_voucher/filter_not_pushed_hostel_vouchers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          voucher_type: voucherTypeString,
          student_type: notPushedStudentType,
          start_date: notPushedStartDate,
          end_date: notPushedEndDate,
          bank: notPushedBank || "All",
          building_ids: notPushedBuildingIds,
          exclude_zero_fee: notPushedExcludeZeroFee,
        }),
      })

      const data = await response.json()

      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers)
        toast.success(`Found ${data.vouchers.length} vouchers not pushed to SAP`)
        setFilterNotPushedModalOpen(false)
        // resetNotPushedFilterModal()
      } else {
        setVouchers([])
        toast.error(data.error || "No vouchers found for the selected criteria")
      }
    } catch (error) {
      console.error("Error filtering not pushed vouchers:", error)
      toast.error("Error filtering not pushed vouchers")
      setVouchers([])
    } finally {
      setLoading(false)
    }
  }

  const handlePayVoucher = async () => {
    if (!selectedBank || !transactionId.trim() || !paymentDateTime) {
      toast.error("Please fill all required fields")
      return
    }

    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/pay_hostel_voucher`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          voucher_code: payingVoucherCode,
          bank: selectedBank,
          payment_date: paymentDateTime,
          transaction_id: transactionId.trim(),
        }),
      })

      const data = await response.json()

      if (response.ok) {
        toast.success(data.success || "Voucher paid successfully")
        setPayModalOpen(false)
        resetPayModal()
        if (voucherNumber) {
          fetchVoucherByCode()
        }
      } else {
        toast.error(data.error || "Error paying voucher")
      }
    } catch (error) {
      console.error("Error paying voucher:", error)
      toast.error("Error paying voucher")
    } finally {
      setLoading(false)
    }
  }

  const handleUnpayVoucher = async (voucher_code) => {
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/unpay_hostel_voucher`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ voucher_id: voucher_code }),
      })

      const data = await response.json()
      if (response.ok) {
        toast.success(data.success || "Voucher unpaid successfully")
        setVouchers((prev) =>
          prev.map((voucher) =>
            voucher.voucher_code === voucher_code
              ? {
                  ...voucher,
                  voucher_status: "un-paid",
                  is_paid: 0,
                  payment_mode: null,
                  paid_date: null,
                  transaction_id: null,
                }
              : voucher,
          ),
        )
      } else {
        toast.error(data.error || "Error unpaying voucher")
      }
    } catch (error) {
      console.error("Error unpaying voucher:", error)
      toast.error("Error unpaying voucher")
    } finally {
      setLoading(false)
    }
  }

  // Download CSV template for bulk pay
  const downloadTemplate = () => {
    const csvContent =
      "voucher_code,bank,transaction_id,payment_date,amount\n123456,HBL,TXN123456789,2024-01-15T10:30:00,5000\n123457,UBL,TXN987654321,2024-01-15T11:45:00,7500"
    const blob = new Blob([csvContent], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "hostel_bulk_payment_template.csv"
    a.click()
    window.URL.revokeObjectURL(url)
  }

  // Parse CSV file
  const parseCsvFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const text = e.target.result
          const lines = text.split("\n").filter((line) => line.trim())
          const headers = lines[0].split(",").map((h) => h.trim())

          const requiredHeaders = ["voucher_code", "bank", "transaction_id", "payment_date", "amount"]
          const missingHeaders = requiredHeaders.filter((h) => !headers.includes(h))
          if (missingHeaders.length > 0) {
            reject(`Missing required columns: ${missingHeaders.join(", ")}`)
            return
          }

          const data = []
          const errors = []
          for (let i = 1; i < lines.length; i++) {
            const values = lines[i].split(",").map((v) => v.trim())
            const row = {}
            headers.forEach((header, index) => {
              row[header] = values[index] || ""
            })

            const rowErrors = []
            if (!row.voucher_code) rowErrors.push("Voucher code is required")
            if (!row.bank) rowErrors.push("Bank is required")
            if (!BANKS.includes(row.bank)) rowErrors.push(`Bank must be one of: ${BANKS.join(", ")}`)
            if (!row.transaction_id) rowErrors.push("Transaction ID is required")
            if (!row.payment_date) rowErrors.push("Payment date is required")
            if (!row.amount || isNaN(Number.parseFloat(row.amount))) rowErrors.push("Valid amount is required")

            if (rowErrors.length > 0) {
              errors.push(`Row ${i + 1}: ${rowErrors.join(", ")}`)
            } else {
              data.push({
                voucher_id: row.voucher_code,
                bank: row.bank,
                transaction_id: row.transaction_id,
                payment_date: row.payment_date,
                amount: Number.parseFloat(row.amount),
              })
            }
          }
          resolve({ data, errors })
        } catch (error) {
          reject("Error parsing CSV file")
        }
      }
      reader.readAsText(file)
    })
  }

  // Handle CSV upload
  const handleCsvUpload = async (event) => {
    const file = event.target.files[0]
    if (!file) return
    if (file.type !== "text/csv" && !file.name.endsWith(".csv")) {
      toast.error("Please upload a CSV file")
      return
    }

    setCsvFile(file)
    setBulkPayLoading(true)
    try {
      const { data, errors } = await parseCsvFile(file)
      setCsvData(data)
      setCsvErrors(errors)
      setSuccessVouchers([])
      setErrorVouchers([])

      if (errors.length > 0) {
        toast.warning(`CSV uploaded with ${errors.length} errors. Please review before proceeding.`)
      } else {
        toast.success(`CSV uploaded successfully. ${data.length} records ready for processing.`)
      }
    } catch (error) {
      toast.error(error)
      setCsvData([])
      setCsvErrors([])
    } finally {
      setBulkPayLoading(false)
    }
  }

  // Process bulk pay
  const handleBulkPay = async () => {
    if (csvData.length === 0) {
      toast.error("No valid data to process")
      return
    }
    if (csvErrors.length > 0) {
      toast.error("Please fix all errors before proceeding")
      return
    }

    setBulkPayLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/bulk_pay_hostel_vouchers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ payments: csvData }),
      })
      const data = await response.json()

      if (response.ok) {
        toast.success(`Bulk payment processed. ${data.success?.length || 0} vouchers paid.`)
        setSuccessVouchers(data.success || [])
        setErrorVouchers(data.errors || [])
        setCsvFile(null)
        setCsvData([])
        setCsvErrors([])
        if (voucherNumber) {
          fetchVoucherByCode()
        }
      } else {
        toast.error(data.error || "Error processing bulk payment")
      }
    } catch (error) {
      console.error("Error processing bulk pay:", error)
      toast.error("Error processing bulk payment")
    } finally {
      setBulkPayLoading(false)
    }
  }

  const resetBulkPayModal = () => {
    setBulkPayModalOpen(false)
    setCsvFile(null)
    setCsvData([])
    setCsvErrors([])
    setSuccessVouchers([])
    setErrorVouchers([])
  }

  // Push to SAP
  const handlePushToSAP = async (voucher_code) => {
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/push_to_sap_hostel_voucher`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          voucher_code: voucher_code,
        }),
      })

      const data = await response.json()

      if (response.ok) {
        toast.success(data.success || "Voucher pushed to SAP successfully")
        if (voucherNumber) {
          fetchVoucherByCode()
        }
      } else {
        toast.error(data.error || "Error pushing voucher to SAP")
      }
    } catch (error) {
      console.error("Error pushing to SAP:", error)
      toast.error("Error pushing voucher to SAP")
    } finally {
      setLoading(false)
    }
  }

  // Bulk Push to SAP
  const handleBulkPushToSap = async () => {
    // Filter vouchers that are paid and not already pushed to SAP
    const eligibleVouchers = vouchers.filter(
      (v) => v.voucher_status === "paid" && v.is_added_to_sap !== 1
    )

    if (eligibleVouchers.length === 0) {
      toast.error("No eligible vouchers found. Vouchers must be paid and not already pushed to SAP.")
      return
    }

    setLoading(true)
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/bulk_push_to_sap_hostel_vouchers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            voucher_codes: eligibleVouchers.map((v) => v.voucher_code),
          }),
        }
      )
      const data = await response.json()
      if (response.ok) {
        toast.success(
          `Bulk push to SAP successfully started in background for ${eligibleVouchers.length} vouchers`
        )
      } else {
        toast.error(data.error || "Error in bulk push to SAP")
      }
    } catch (error) {
      console.error("Error in bulk push to SAP:", error)
      toast.error("Error in bulk push to SAP")
    } finally {
      setLoading(false)
    }
  }

  // Open pay voucher modal
  const handlePayVoucherClick = (voucher_code) => {
    setPayingVoucherCode(voucher_code)
    setPayModalOpen(true)
  }

  const handleViewLog = async (voucher) => {
    const new_voucher = vouchers.find((v) => v.voucher_code === voucher.voucher_code)
    setLogVoucher(new_voucher)
    setActionLogs([])
    setLogModalOpen(true)
    setActionLogsLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/get_hostel_voucher_action_logs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ voucher_code: voucher.voucher_code }),
      })
      const data = await response.json()
      if (response.ok && Array.isArray(data.logs)) {
        setActionLogs(data.logs)
      } else {
        toast.error(data.error || "Unable to fetch action logs")
      }
    } catch (error) {
      console.error("Error fetching action logs:", error)
      toast.error("Error fetching action logs")
    } finally {
      setActionLogsLoading(false)
    }
  }

  // Reset modals
  const resetPayModal = () => {
    setSelectedBank("")
    setTransactionId("")
    setPaymentDateTime("")
    setPayingVoucherCode("")
  }

  const resetFilterModal = () => {
    setFilterVoucherTypes("")
    setFilterStatus("")
    setFilterStudentType("")
    setFilterStartDate("")
    setFilterEndDate("")
    setFilterBank("")
    setFilterBuildingIds([])
  }

  const resetNotPushedFilterModal = () => {
    setNotPushedVoucherTypes("")
    setNotPushedStudentType("")
    setNotPushedStartDate("")
    setNotPushedEndDate("")
    setNotPushedBank("")
    setNotPushedBuildingIds([])
    setNotPushedExcludeZeroFee(false)
  }

  // Table columns
  const columns = [
    { Header: "Voucher Code", accessor: "voucher_code", align: "center" },
    { Header: "Voucher Type", accessor: "voucher_type", align: "center" },
    {
      Header: "Status",
      accessor: "voucher_status",
      align: "center",
      Cell: ({ value }) => (
        <MDBadge
          badgeContent={value === "paid" ? "Paid" : "Not Paid"}
          color={value === "paid" ? "success" : "warning"}
          variant="gradient"
          size="sm"
        />
      ),
    },
    { Header: "Amount", accessor: "amount", align: "center" },
    { Header: "Due Date", accessor: "due_date", align: "center" },
    { Header: "Transaction ID", accessor: "transaction_id", align: "center" },
    { Header: "Payment Date", accessor: "payment_date", align: "center" },
    { Header: "Student Name", accessor: "student_name", align: "center" },
    { Header: "Student CNIC", accessor: "cnic", align: "center" },
    { Header: "Building", accessor: "building", align: "center" },
    { Header: "Cost Center", accessor: "cost_center", align: "center" },
    { Header: "BP No", accessor: "bp_no", align: "center" },
    { Header: "Payment ID", accessor: "payment_id", align: "center" },
    {
      Header: "Actions",
      accessor: "actions",
      align: "center",
      Cell: ({ row }) => (
        <MDBox display="flex" gap={1} justifyContent="center" flexWrap="wrap">
          {row.original.voucher_status === "paid" ? (
            <Button
              variant="contained"
              color="warning"
              size="small"
              disabled={loading}
              onClick={() => handleUnpayVoucher(row.original.voucher_code)}
              sx={{ minWidth: "60px", fontSize: "0.75rem" }}
            >
              Unpay
            </Button>
          ) : (
            <Button
              variant="contained"
              color="success"
              size="small"
              disabled={loading}
              onClick={() => handlePayVoucherClick(row.original.voucher_code)}
              sx={{ minWidth: "60px", fontSize: "0.75rem" }}
            >
              Pay
            </Button>
          )}
          {/* {hasAdmissionPermission("HostelVouchers", "MANAGE") && ( */}
          <Button
            variant="contained"
            color="info"
            size="small"
            disabled={loading}
            onClick={() => handlePushToSAP(row.original.voucher_code)}
            sx={{ minWidth: "80px", fontSize: "0.75rem" }}
          >
            Push to SAP
          </Button>
          
          {/* {hasAdmissionPermission("HostelVouchers", "MANAGE") && ( */}
          <Button
            variant="contained"
            color="secondary"
            size="small"
            disabled={loading}
            onClick={() => handleViewLog(row.original)}
            startIcon={<VisibilityIcon />}
            sx={{ minWidth: "80px", fontSize: "0.75rem" }}
            style={{ color: "white" }}
          >
            View Log
          </Button>
        </MDBox>
      ),
    },
  ]

  // Table rows
  const rows = vouchers.map((v) => ({
    voucher_code: v.voucher_code,
    voucher_type: v.voucher_type,
    voucher_status: v.voucher_status,
    amount: v.amount,
    due_date: v.expiry_date
      ? new Date(v.expiry_date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric",
          timeZone: "Asia/Karachi",
        })
      : "N/A",
    transaction_id: v.transaction_id || "N/A",
    payment_date: v.paid_date
      ? new Date(v.paid_date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric",
          timeZone: "Asia/Karachi",
        })
      : "N/A",
    student_name: v.requester_name,
    cnic: v.cnic || "N/A",
    building: v.building_name || "N/A",
    cost_center: v.building_cost_center || "N/A",
    bp_no: v.bp_no || "N/A",
    payment_id: v.payment_id || "N/A",
  }))

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card className="mb-4">
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="medium" mb={2}>
                  Hostel Voucher Management
                </MDTypography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={3}>
                    <Paper
                      component="form"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Enter Voucher Code"
                        inputProps={{ "aria-label": "voucher code" }}
                        value={voucherNumber}
                        onChange={(e) => setVoucherNumber(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault()
                            fetchVoucherByCode()
                          }
                        }}
                      />
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={fetchVoucherByCode}
                      disabled={loading}
                      startIcon={<SearchIcon />}
                      style={{ color: "white", width: "100%" }}
                    >
                      {loading ? <CircularProgress size={20} color="inherit" /> : "Search"}
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="info"
                      onClick={() => setBulkSearchModalOpen(true)}
                      disabled={loading}
                      style={{ color: "black", width: "100%" }}
                    >
                      Multiple Search
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="info"
                      onClick={() => setFilterModalOpen(true)}
                      disabled={loading}
                      style={{ color: "black", width: "100%" }}
                      startIcon={<FilterListIcon />}
                    >
                      Filter Vouchers
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="warning"
                      onClick={() => setFilterNotPushedModalOpen(true)}
                      disabled={loading}
                      style={{ color: "black", width: "100%" }}
                      startIcon={<FilterListIcon />}
                    >
                      Not Pushed to SAP
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={getManualPaidVouchers}
                      disabled={loading}
                      style={{ color: "white", width: "100%" }}
                    >
                      {loading ? <CircularProgress size={20} color="inherit" /> : "GET Manual Paid Vouchers"}
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setBulkPayModalOpen(true)}
                      disabled={loading}
                      style={{ color: "white", width: "100%" }}
                    >
                      Bulk Pay
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="info"
                      onClick={downloadTemplate}
                      disabled={loading}
                      startIcon={<GetAppIcon />}
                      style={{ color: "black", width: "100%" }}
                    >
                      Template
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={exportVouchers}
                      disabled={!vouchers || vouchers.length === 0}
                      startIcon={<DownloadIcon />}
                      style={{ color: "white", width: "100%" }}
                    >
                      Export CSV
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleBulkPushToSap}
                      disabled={!vouchers || vouchers.length === 0 || loading}
                      style={{ color: "white", width: "100%" }}
                      startIcon={<CloudUploadIcon />}
                    >
                      {loading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        "Push to SAP (Bulk)"
                      )}
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={1}></Grid>
                </Grid>
              </MDBox>
            </Card>

            <Card>
              <MDBox pt={3} pb={3}>
                {loading ? (
                  <MDBox display="flex" justifyContent="center" p={5}>
                    <CircularProgress />
                  </MDBox>
                ) : vouchers && vouchers.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <MDBox display="flex" flexDirection="column" alignItems="center" p={5}>
                    <MDTypography variant="body1" mt={2}>
                      No vouchers found. Please search by voucher code or use filters to see results.
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Pay Voucher Modal */}
      <Dialog
        open={payModalOpen}
        onClose={() => {
          setPayModalOpen(false)
          resetPayModal()
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Pay Hostel Voucher</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <TextField
              fullWidth
              margin="normal"
              label="Voucher Code"
              value={payingVoucherCode}
              disabled
              variant="outlined"
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Bank</InputLabel>
              <Select
                value={selectedBank}
                onChange={(e) => setSelectedBank(e.target.value)}
                label="Select Bank"
                style={{ height: "56px" }}
              >
                {BANKS.map((bank) => (
                  <MenuItem key={bank} value={bank}>
                    {bank}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              margin="normal"
              label="Transaction ID"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              required
              variant="outlined"
            />
            <TextField
              fullWidth
              margin="normal"
              label="Payment Date & Time"
              type="datetime-local"
              value={paymentDateTime}
              onChange={(e) => setPaymentDateTime(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setPayModalOpen(false)
              resetPayModal()
            }}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={handlePayVoucher}
            color="primary"
            variant="contained"
            disabled={loading || !selectedBank || !transactionId.trim()}
            style={{ color: "white" }}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : "Pay Voucher"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={bulkSearchModalOpen} onClose={() => setBulkSearchModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Search Multiple Hostel Vouchers</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <TextField
              fullWidth
              multiline
              minRows={6}
              label="Paste voucher codes / CSV column"
              value={bulkSearchInput}
              onChange={(e) => setBulkSearchInput(e.target.value)}
              placeholder={"Example:\n300001\n300002\n300003"}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBulkSearchModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleBulkVoucherSearch}
            color="primary"
            variant="contained"
            disabled={bulkSearchLoading}
            style={{ color: "black" }}
          >
            {bulkSearchLoading ? <CircularProgress size={20} color="inherit" /> : "Search"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Pay Modal */}
      <Dialog open={bulkPayModalOpen} onClose={resetBulkPayModal} maxWidth="md" fullWidth>
        <DialogTitle>Hostel Bulk Payment Upload</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <Alert severity="info" sx={{ mb: 3 }}>
              <AlertTitle>Instructions for Bulk Payment</AlertTitle>
              <MDTypography variant="body2" mb={1}>
                1. Download the CSV template and keep the same column names.
              </MDTypography>
              <MDTypography variant="body2" mb={1}>
                2. Required columns: voucher_code, bank, transaction_id, payment_date, amount
              </MDTypography>
              <MDTypography variant="body2" mb={1}>
                3. Bank must be one of: {BANKS.join(", ")}
              </MDTypography>
              <MDTypography variant="body2" mb={1}>
                4. Payment date format: YYYY-MM-DDTHH:MM:SS (example: 2024-01-15T10:30:00)
              </MDTypography>
              <MDTypography variant="body2">
                5. Upload CSV and click Process Bulk Payment.
              </MDTypography>
            </Alert>

            <Box sx={{ mb: 3 }}>
              <input
                accept=".csv"
                style={{ display: "none" }}
                id="hostel-csv-upload"
                type="file"
                onChange={handleCsvUpload}
              />
              <label htmlFor="hostel-csv-upload">
                <Button
                  variant="contained"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                  style={{ color: "white" }}
                  fullWidth
                  sx={{ mb: 2, height: "50px" }}
                >
                  {csvFile ? csvFile.name : "Choose CSV File"}
                </Button>
              </label>
            </Box>

            {bulkPayLoading && !csvData.length && !csvErrors.length && (
              <Box display="flex" justifyContent="center" my={2}>
                <CircularProgress />
                <MDTypography variant="body2" ml={2}>
                  Processing CSV file...
                </MDTypography>
              </Box>
            )}

            {csvData.length > 0 && (
              <Alert severity="success" sx={{ mb: 2 }}>
                <AlertTitle>CSV Data Preview</AlertTitle>
                <MDTypography variant="body2" mb={1}>
                  Successfully parsed {csvData.length} records
                </MDTypography>
                <div style={{ maxHeight: "200px", overflow: "auto", minWidth: "500px" }}>
                  <table style={{ width: "500px", fontSize: "12px", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ backgroundColor: "#f5f5f5" }}>
                        <th style={{ border: "1px solid #ddd", padding: "4px" }}>Voucher Code</th>
                        <th style={{ border: "1px solid #ddd", padding: "4px" }}>Bank</th>
                        <th style={{ border: "1px solid #ddd", padding: "4px" }}>Transaction ID</th>
                        <th style={{ border: "1px solid #ddd", padding: "4px" }}>Payment Date</th>
                        <th style={{ border: "1px solid #ddd", padding: "4px" }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {csvData.map((row, index) => (
                        <tr key={index}>
                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>{row.voucher_id}</td>
                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>{row.bank}</td>
                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>{row.transaction_id}</td>
                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>{row.payment_date}</td>
                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>{row.amount}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Alert>
            )}

            {csvErrors.length > 0 && (
              <Alert severity="error" sx={{ mb: 2 }}>
                <AlertTitle>CSV Validation Errors</AlertTitle>
                <div className="box" style={{ maxHeight: "200px", overflow: "auto", minWidth: "500px" }}>
                  {csvErrors.map((error, index) => (
                    <MDTypography key={index} variant="body2" sx={{ mb: 0.5 }}>
                      - {error}
                    </MDTypography>
                  ))}
                </div>
              </Alert>
            )}

            {successVouchers.length > 0 && (
              <Alert severity="success" sx={{ mb: 2 }}>
                <AlertTitle>Successful Payments</AlertTitle>
                <div className="box" style={{ maxHeight: "200px", overflow: "auto", minWidth: "500px" }}>
                  {successVouchers.map((voucher, index) => (
                    <MDTypography key={index} variant="body2" sx={{ mb: 0.5 }}>
                      - {voucher} - Paid
                    </MDTypography>
                  ))}
                </div>
              </Alert>
            )}

            {errorVouchers.length > 0 && (
              <Alert severity="error" sx={{ mb: 2 }}>
                <AlertTitle>Failed Payments</AlertTitle>
                <div className="box" style={{ maxHeight: "200px", overflow: "auto", minWidth: "500px" }}>
                  {errorVouchers.map((voucher, index) => (
                    <MDTypography key={index} variant="body2" sx={{ mb: 0.5 }}>
                      - {voucher.voucher_id} - {voucher.error || "Unknown error"}
                    </MDTypography>
                  ))}
                </div>
              </Alert>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={resetBulkPayModal} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleBulkPay}
            color="primary"
            variant="contained"
            disabled={bulkPayLoading || csvData.length === 0 || csvErrors.length > 0}
            style={{ color: "white" }}
          >
            {bulkPayLoading ? <CircularProgress size={20} color="inherit" /> : "Process Bulk Payment"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Filter Vouchers Modal */}
      <Dialog
        open={filterModalOpen}
        onClose={() => {
          setFilterModalOpen(false)
          resetFilterModal()
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Filter Hostel Vouchers</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Voucher Type</InputLabel>
              <Select
                value={filterVoucherTypes}
                onChange={(e) => setFilterVoucherTypes(e.target.value)}
                label="Voucher Type"
                style={{ height: "56px" }}
              >
                {FILTER_VOUCHER_TYPES.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel>Select Status</InputLabel>
              <Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                label="Select Status"
                style={{ height: "56px" }}
              >
                {VOUCHER_STATUS.map((status) => (
                  <MenuItem key={status} value={status}>
                    {status === "paid" ? "Paid" : "Unpaid"}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel>Student Type</InputLabel>
              <Select
                value={filterStudentType}
                onChange={(e) => setFilterStudentType(e.target.value)}
                label="Student Type"
                style={{ height: "56px" }}
              >
                {STUDENT_TYPES.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel>Select Bank (Optional)</InputLabel>
              <Select
                value={filterBank}
                onChange={(e) => setFilterBank(e.target.value)}
                label="Select Bank (Optional)"
                style={{ height: "56px" }}
              >
                <MenuItem value="All">
                  <em>All Banks</em>
                </MenuItem>
                {BANKS.map((bank) => (
                  <MenuItem key={bank} value={bank}>
                    {bank}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel>Select Buildings (Optional)</InputLabel>
              <Select
                multiple
                value={filterBuildingIds}
                onChange={(e) => setFilterBuildingIds(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                input={<OutlinedInput label="Select Buildings (Optional)" />}
                renderValue={(selected) => {
                  if (selected.length === 0) return "All Buildings"
                  if (selected.length === buildings.length) return "All Buildings"
                  return selected.map(id => {
                    const building = buildings.find(b => b.id === id)
                    return building ? building.building_name : id
                  }).join(", ")
                }}
              >
                {buildings.map((building) => (
                  <MenuItem key={building.id} value={building.id}>
                    <Checkbox checked={filterBuildingIds.indexOf(building.id) > -1} />
                    <ListItemText primary={building.building_name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              margin="normal"
              label="Start Date"
              type="date"
              value={filterStartDate}
              onChange={(e) => setFilterStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="End Date"
              type="date"
              value={filterEndDate}
              onChange={(e) => setFilterEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setFilterModalOpen(false)
              resetFilterModal()
            }}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={filterVouchers}
            color="primary"
            variant="contained"
            disabled={
              loading ||
              !filterVoucherTypes ||
              !filterStatus ||
              !filterStudentType ||
              !filterStartDate ||
              !filterEndDate
            }
            style={{ color: "white" }}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : "Apply Filter"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Filter Not Pushed to SAP Modal */}
      <Dialog
        open={filterNotPushedModalOpen}
        onClose={() => {
          setFilterNotPushedModalOpen(false)
          resetNotPushedFilterModal()
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Filter Vouchers Not Pushed to SAP</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Voucher Type</InputLabel>
              <Select
                value={notPushedVoucherTypes}
                onChange={(e) => setNotPushedVoucherTypes(e.target.value)}
                label="Voucher Type"
                style={{ height: "56px" }}
              >
                {FILTER_VOUCHER_TYPES.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel>Student Type</InputLabel>
              <Select
                value={notPushedStudentType}
                onChange={(e) => setNotPushedStudentType(e.target.value)}
                label="Student Type"
                style={{ height: "56px" }}
              >
                {STUDENT_TYPES.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel>Select Bank (Optional)</InputLabel>
              <Select
                value={notPushedBank}
                onChange={(e) => setNotPushedBank(e.target.value)}
                label="Select Bank (Optional)"
                style={{ height: "56px" }}
              >
                <MenuItem value="All">
                  <em>All Banks</em>
                </MenuItem>
                {BANKS.map((bank) => (
                  <MenuItem key={bank} value={bank}>
                    {bank}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel>Select Buildings (Optional)</InputLabel>
              <Select
                multiple
                value={notPushedBuildingIds}
                onChange={(e) => setNotPushedBuildingIds(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                input={<OutlinedInput label="Select Buildings (Optional)" />}
                renderValue={(selected) => {
                  if (selected.length === 0) return "All Buildings"
                  if (selected.length === buildings.length) return "All Buildings"
                  return selected.map(id => {
                    const building = buildings.find(b => b.id === id)
                    return building ? building.building_name : id
                  }).join(", ")
                }}
              >
                {buildings.map((building) => (
                  <MenuItem key={building.id} value={building.id}>
                    <Checkbox checked={notPushedBuildingIds.indexOf(building.id) > -1} />
                    <ListItemText primary={building.building_name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={notPushedExcludeZeroFee}
                  onChange={(e) => setNotPushedExcludeZeroFee(e.target.checked)}
                />
              }
              label="Exclude vouchers with 0 fee"
              sx={{ mt: 1 }}
            />

            <TextField
              fullWidth
              margin="normal"
              label="Payment from"
              type="date"
              value={notPushedStartDate}
              onChange={(e) => setNotPushedStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Payment to"
              type="date"
              value={notPushedEndDate}
              onChange={(e) => setNotPushedEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setFilterNotPushedModalOpen(false)
              resetNotPushedFilterModal()
            }}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={filterNotPushedToSAP}
            color="primary"
            variant="contained"
            disabled={
              loading ||
              !notPushedVoucherTypes ||
              !notPushedStartDate ||
              !notPushedEndDate ||
              !notPushedStudentType
            }
            style={{ color: "white" }}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : "Apply Filter"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Log Modal */}
      <Dialog
        open={logModalOpen}
        onClose={() => {
          setLogModalOpen(false)
          setLogVoucher(null)
          setActionLogs([])
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Voucher Response Logs</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            {logVoucher ? (
              <MDBox>
                {/* Action Logs */}
                <MDBox mb={3}>
                  <MDTypography variant="h6" fontWeight="medium" mb={1}>
                    Action Logs
                  </MDTypography>
                  {actionLogsLoading ? (
                    <MDBox display="flex" justifyContent="center" py={2}>
                      <CircularProgress size={24} />
                    </MDBox>
                  ) : actionLogs.length > 0 ? (
                    <Paper
                      sx={{
                        p: 2,
                        backgroundColor: "#f5f5f5",
                        maxHeight: "250px",
                        overflowY: "auto",
                      }}
                    >
                      {actionLogs.map((log) => (
                        <MDBox
                          key={log.id}
                          mb={2}
                          p={1.5}
                          sx={{ border: "1px solid #e0e0e0", borderRadius: "8px", backgroundColor: "#fff" }}
                        >
                          <MDTypography variant="button" fontWeight="bold">
                            {log.action || "N/A"}
                          </MDTypography>
                          <MDTypography variant="caption" display="block">
                            By: {log.performed_by_name || log.performed_by || "N/A"}
                          </MDTypography>
                          <MDTypography variant="caption" display="block" mb={1}>
                            At: {log.createdAt ? new Date(log.createdAt).toLocaleString() : "N/A"}
                          </MDTypography>
                          <MDTypography variant="caption" fontWeight="bold" display="block">
                            Previous Data:
                          </MDTypography>
                          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", marginTop: 4 }}>
                            {log.previous_data ? JSON.stringify(log.previous_data, null, 2) : "N/A"}
                          </pre>
                          <MDTypography variant="caption" fontWeight="bold" display="block">
                            New Data:
                          </MDTypography>
                          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", marginTop: 4 }}>
                            {log.new_data ? JSON.stringify(log.new_data, null, 2) : "N/A"}
                          </pre>
                        </MDBox>
                      ))}
                    </Paper>
                  ) : (
                    <MDTypography variant="body2" color="textSecondary">
                      No action logs available
                    </MDTypography>
                  )}
                </MDBox>

                {/* BP Response */}
                <MDBox mb={3}>
                  <MDTypography variant="h6" fontWeight="medium" mb={1}>
                    BP Response
                  </MDTypography>
                  <Paper
                    sx={{
                      p: 2,
                      backgroundColor: "#f5f5f5",
                      maxHeight: "200px",
                      overflowY: "auto",
                      fontFamily: "monospace",
                      fontSize: "0.875rem",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {logVoucher.bp_response}
                  </Paper>
                </MDBox>

                {/* Create Response (SAP Response Invoice) */}
                <MDBox mb={3}>
                  <MDTypography variant="h6" fontWeight="medium" mb={1}>
                    Create Response
                  </MDTypography>
                  <Paper
                    sx={{
                      p: 2,
                      backgroundColor: "#f5f5f5",
                      maxHeight: "200px",
                      overflowY: "auto",
                      fontFamily: "monospace",
                      fontSize: "0.875rem",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {logVoucher.sap_response ? (
                      typeof logVoucher.sap_response === "string" ? (
                        logVoucher.sap_response
                      ) : (
                        JSON.stringify(logVoucher.sap_response, null, 2)
                      )
                    ) : (
                      <MDTypography variant="body2" color="textSecondary">
                        No data available
                      </MDTypography>
                    )}
                  </Paper>
                </MDBox>

                {/* Payment Response (SAP Response) */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" mb={1}>
                    Payment Response
                  </MDTypography>
                  <Paper
                    sx={{
                      p: 2,
                      backgroundColor: "#f5f5f5",
                      maxHeight: "200px",
                      overflowY: "auto",
                      fontFamily: "monospace",
                      fontSize: "0.875rem",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {logVoucher.sap_response_invoice ? (
                      typeof logVoucher.sap_response_invoice === "string" ? (
                        logVoucher.sap_response_invoice
                      ) : (
                        JSON.stringify(logVoucher.sap_response_invoice, null, 2)
                      )
                    ) : (
                      <MDTypography variant="body2" color="textSecondary">
                        No data available
                      </MDTypography>
                    )}
                  </Paper>
                </MDBox>
              </MDBox>
            ) : (
              <MDTypography variant="body2" color="textSecondary">
                No voucher data available
              </MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setLogModalOpen(false)
              setLogVoucher(null)
              setActionLogs([])
            }}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  )
}

export default HostelVouchers